import { render, staticRenderFns } from "./payment-login.vue?vue&type=template&id=0a389688&"
import script from "./payment-login.vue?vue&type=script&lang=js&"
export * from "./payment-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports